<template>
    <div
      class="tile m-2 p-2 rounded-lg flex flex-col items-center relative"
      :style="styles.base"
    >
      <div v-if="data.tooltip" :style="styles.tooltip" class="min-w-1 absolute pin-t pin-r mr-2 -mt-3 flex justify-center align-center">{{ data.tooltip }}</div>
      <div class="w-full flex mb-3"> <!-- header -->
        <i class="fas fa-2x mr-2" :class="data.icon"></i>
        <div class="flex flex-col justify-center">
          <h1 v-if="data.title" class="text-sm font-bold">{{ data.title }}</h1>
          <h3 v-if="data.subtitle" class="text-xs font-medium">{{ data.subtitle }}</h3>
        </div>
      </div> <!-- header end -->

      <p v-if="data.text" class="w-full text-sm mb-2 flex-1 mb-2">
        {{ data.text }}
      </p>

      <div v-if="data.actions" class="w-full flex flex-wrap justify-around align-center mt-auto mb-2">
        <button
          v-for="(action, index) in data.actions"
          :key="index"
          class="rounded px-5 py-1 focus:outline-none"
          :class="{ 'mt-1': index > 0 }"
          :style="styles.action"
          type="button"
          @mousedown.stop
          @click.stop="actionPressed(action, data)"
        >
          {{ action.label }}
        </button>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { EventBus } from '@/EventBus'

export default {
  name: 'tile',

  props: {
    styles: Object,
    data: Object
  },

  computed: {
    ...mapState(['digitalHubLink'])
  },

  methods: {
    ...mapActions([
      'authInsight',
      'authGoldMarketingPack',
      'displayToastNotification',
      'ssoToEasyProperty'
    ]),

    actionPressed (action, data) {
      if (action.route === '@showSelector') {
        EventBus.$emit('tile:show-selector')
      } else if (action.route === 'insight') {
        this.authInsight()
      } else if (action.route === 'gmp') {
        this.authGoldMarketingPack()
      } else if (action.route === 'digital-hub') {
        this.openDigitalHub()
      } else if (action.route === 'easy-property-sso-dashboard') {
        this.ssoToEasyProperty()
      } else if (action.route.startsWith('https://') || action.route.startsWith('http://')) {
        window.open(action.route, '_blank')
      } else {
        this.$router.push(action.route)
      }
    },

    openDigitalHub () {
      if (this.digitalHubLink) {
        window.open(this.digitalHubLink, '_blank')
      } else {
        this.displayToastNotification({
          type: 'warning',
          icon: 'fa-bell',
          title: 'Unable to login to Digital Hub',
          info: ''
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.tile
  height: 140px
  background: grey
</style>
